import { Navigate, Outlet } from "react-router-dom";
import useAuthService from "../session/useAuthService";

const PrivateRoutes = () => {
  let auth = useAuthService.getToken();
  return auth === "Bearer null" ? <Navigate to="/login" /> : <Outlet />;
};

export default PrivateRoutes;
